import React from 'react';
import { Trans } from 'react-i18next';

import styles from './UnsavedInformationNotice.module.css';

const UnsavedInformationNotice = () => (
  <div aria-live="polite" className={styles.container} role="status">
    <Trans
      components={{ bold: <strong className={styles.important} /> }}
      i18nKey="policyInformation.unsavedInformationNotice"
      ns="petDemos"
    />
  </div>
);

export { UnsavedInformationNotice };
